<script lang="ts">
	// Footer link type
	type FooterLink = {
		title: string;
		href: string;
	};

	// Footer links
	const legalLinks: FooterLink[] = [
		{ title: 'Privacy', href: '/privacy' },
		{ title: 'Terms', href: '/terms' }
	];
</script>

<footer class="border-t">
	<div class="container flex h-16 items-center justify-between">
		<!-- Copyright -->
		<p class="text-sm text-muted-foreground">
			© {new Date().getFullYear()} thinkfox.ai. All rights reserved.
		</p>

		<!-- Legal links -->
		<nav class="flex gap-4">
			{#each legalLinks as link}
				<a
					href={link.href}
					class="text-sm text-muted-foreground hover:text-primary transition-colors"
				>
					{link.title}
				</a>
			{/each}
		</nav>
	</div>
</footer>
